<div class="{{ inlineLabel ? 'inline' : '' }}">
  <div class="label-container">
    @if (label) {
      <label data-cy="text-field-label">
        {{ label }}
        @if (isRequired) {
          <strong>*</strong>
        }
      </label>
    }
    @if (maxChars) {
      <span [ngClass]="{ 'error-message': isMaxCharsReached }">Characters: {{ inputTextLength }}/{{ maxChars }}</span>
    }
  </div>
  <div class="input-container">
    @if (iconUrl && !iconLinkUrl) {
      <img src="{{ iconUrl }}" class="img-no-link" />
    }
    @if (iconUrl && iconLinkUrl) {
      <a [routerLink]="iconLinkUrl" target="_blank"><img src="{{ iconUrl }}" /></a>
    }
    <input
      [type]="type"
      [disabled]="disabled"
      [readonly]="readonly"
      (input)="onChange($event)"
      [placeholder]="placeholder"
      [ngClass]="[feedback || '', size, error ? 'error' : '']"
      [ngStyle]="inputPaddingRight && { 'padding-right': inputPaddingRight }"
      [style.backgroundColor]="inputBackgroundColor"
      [value]="type === 'date' || type === 'datetime-local' ? getDate(value) : value"
      (keyup)="maxChars && validateMaxChars($event.target.value.length)"
      (blur)="validateRequired($event.target.value.length)"
      data-cy="input-field"
    />
  </div>
  @if (error) {
    <div class="error-message">{{ error }}</div>
  }
</div>
